import { Component, EventEmitter, OnInit, Output, ViewChild, AfterViewInit } from '@angular/core';

import { AppComponent } from 'src/app/app.component';
import { MainComponent } from '../../main/main.component';
import { environment } from 'src/environments/environment';
import { MapComponent, MapLatLng, MapMarker } from 'movisat-maps';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxRibbonComponent } from 'jqwidgets-ng/jqxribbon';
import { jqxDropDownListComponent } from 'jqwidgets-ng/jqxdropdownlist';

import { SsoService } from 'src/app/services/sso/sso.service';
import { ZonesService } from 'src/app/services/zones/zones.service';
import { CatastroService } from 'src/app/services/direccion/catastro.service';
import { CiudadanosService } from 'src/app/services/ciudadanos/ciudadanos.service';

import { TicketModel } from 'src/app/services/sso/models/ticket.model';
import { CiudadanoModel } from 'src/app/services/ciudadanos/models/ciudadano.model';
import { DireccionModel } from 'src/app/services/ciudadanos/models/direccion.model';

import { CiudadanosTarjetasComponent } from '../ciudadanos-tarjetas/ciudadanos-tarjetas.component';
import { SelectorCatastroComponent } from '../direccion/selector-catastro/selector-catastro.component';
import { DireccionListadoComponent } from '../direccion/direccion-listado/direccion-listado.component';
import { RequiredLopdFormCiudadanoView } from 'src/app/interfaces/required-lopd-form-ciudadano-view';
import { WindowComponent } from 'movisat-common-gui';

@Component({
  selector: 'app-ciudadanos-edit',
  templateUrl: './ciudadanos-edit.component.html',
  styleUrls: ['./ciudadanos-edit.component.css']
})

export class CiudadanosEditComponent implements OnInit, AfterViewInit {
  @Output() createCiudadano: EventEmitter<any>=new EventEmitter<any>();

  // Componentes del html
  @ViewChild('formWindow') windowCiudadanosForm: WindowComponent;
  @ViewChild('ciudRibbon') ciudRibbon: jqxRibbonComponent;
  @ViewChild('gridDirecciones') gridDirecciones: jqxGridComponent;
  @ViewChild('mapSearch') mapSearch: any;
  @ViewChild('dropValidado') dropValidado: jqxDropDownListComponent;
  @ViewChild('selectorCatastro') selectorCatastro: SelectorCatastroComponent;

  @ViewChild('ciudadanoTarjetas') ciudadanoTarjetas: CiudadanosTarjetasComponent;
  @ViewChild('ciudadanoDirecciones') ciudadanoDirecciones: DireccionListadoComponent;
  inputMapSearch: HTMLInputElement;

  // Funcionalidad
  public static _this: CiudadanosEditComponent;
  private componentRef = null;
  public environment = environment;
  public langGrid = JqWidgets.getLocalization('es');

  //Comprobaciones
  showLoader: boolean = false;
  public guardar = false;
  ciudadanoEmailExist = false;
  public ecoIdentificadores = false;
  public ecoCompostaje = false;

  // Centrar mapa y añadir marca
  public map: MapComponent;
  public marker: MapMarker;

  // TODO: transformar a un signal
  public ciudadano: CiudadanoModel;

  // Generales
  protected direccion: DireccionModel;
  public rol;
  public source: string[] =
    [
      AppComponent.translate('Pendiente'),
      AppComponent.translate('Validado'),
      AppComponent.translate('Rechazado')
    ]

  // LOPD
  camposLopd: RequiredLopdFormCiudadanoView = {};

  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  constructor(
    protected ciudadanoService: CiudadanosService,
    private ssoService: SsoService,
    private catastroService: CatastroService,
    private zonesService: ZonesService,
  ) {
    CiudadanosEditComponent._this = this;
  }

  async ngOnInit(): Promise<void> {
    let ticketSso: TicketModel = JSON.parse(sessionStorage.getItem('ticketSSO'));

    // Comprueba si tiene el modulo ecoidentificadores
    if (ticketSso && ticketSso.Modulos) {
      ticketSso.Modulos.forEach(element => {
        if (element.Id === 4) {
          this.ecoIdentificadores = true;
        }
      });
    }

    // Comprueba si tiene la aplicacion de ecoCompostaje
    if (ticketSso && ticketSso.Aplicacion) {
      if (ticketSso.Aplicacion.Id == 4) {
        this.ecoCompostaje = true;
      }
    }

    // Instancia el mapa
    this.map = MainComponent.getInstance().getMap();

    // Obtiene idioma
    this.langGrid = JqWidgets.getLocalization(this.ssoService.getTicket().Usuario.Idioma.Codigo.substring(0, 2));

    this.guardar = false;
  }

  public async init(componentRef: any, ciudadano: CiudadanoModel) {
    // Inicializa el componente
    this.componentRef = componentRef;

    // Obtiene el rol del usuario logueado
    this.rol = this.ssoService.getTicket().Rol;

    // Obtiene el ciudadano para modificar
    this.ciudadano = ciudadano ? await this.ciudadanoService.getCiudadano(ciudadano.id) : new CiudadanoModel;

    if (this.dropValidado) {
      if (this.ciudadano?.id !== 0) {
        switch (this.ciudadano.estadoValidacion) {
          case 15:
            this.dropValidado.selectIndex(1);
            break;
          case 16:
            this.dropValidado.selectIndex(2);
            break;
          default:
            this.dropValidado.selectIndex(0);
            break;
        }
      } else {
        this.dropValidado.selectIndex(0);
      }
    }

    this.camposLopd = await this.ciudadanoService.getLopdListAllCiudadanos();

    // Si tiene ciudadano establece el valor para el campo de validacion
    if (ciudadano) {
      switch (ciudadano.estadoValidacion) {
        case 15:
          ciudadano.validadoTexto = this.translate('Validado');
          break;
        case 16:
          ciudadano.validadoTexto = this.translate('Rechazado');
          break;
        default:
          ciudadano.validadoTexto = this.translate('Pendiente');
          break;
      }

      // Inicia el array de tarjetas, si no existe
      if (!this.ciudadano.tarjetas) {
        this.ciudadano.tarjetas = [];
      }
    }
  }

  ngAfterViewInit() {
    this.disableTabs(true);

    this.inputMapSearch = this.mapSearch?.nativeElement.children[0].children[0].children[0].children[0];
  }

  disableTabs(selectAt: boolean = false) {
    try {
      if (this.ciudadano && this.ciudadano.id === 0) {
        this.ciudRibbon.disableAt(1);
        this.ciudRibbon.disableAt(2);
      } else if ((this.ciudadano?.estadoValidacion !== 15 && this.ciudadano?.estadoValidacion !== 1) || this.ciudadano?.direccion==null) {
        this.ciudRibbon.disableAt(1);
        this.ciudRibbon.disableAt(2);
      } else if (selectAt) {
        this.ciudRibbon.selectAt(1);
        this.ciudRibbon.selectAt(2);
        this.ciudRibbon.selectAt(0);
      }
    } catch (error) {
      console.debug(error);
    }
  }

  protected actions = [
    {type: "button", action:"save", value: "", label: this.translate('Guardar')},
    {type: "button", action:"cancel", value: "", label: this.translate('CANCELAR')}
  ];

  public actionButtonClicked(event): void {
    if(event.action === 'save') {
      this.onGuardar();
      return;
    }

    if(event.action === 'cancel') {
      this.onClose()
      return;
    }
  }

  enableTabs() {
    if (this.ciudadano.direccion!=null && ((this.ciudadano.estadoValidacion === 15 || this.ciudadano.estadoValidacion === 1) && this.ciudadano?.direcciones?.length > 0)) {
      this.ciudRibbon.enableAt(2);
      this.ciudRibbon.enableAt(1);
    }
  }

  tabSelected(event: any) {
    if (event?.args?.selectedIndex === 1) {
      this.ciudadanoDirecciones.refreshGrid();
    }

    if (event?.args?.selectedIndex === 2) {
      this.ciudadanoTarjetas.cargarGrids();
    }
  }

  // Elimina el marcador del mapa
  removeMarker() {
    if (this.marker) {
      this.map.removeMarker(this.marker);
    }
  }

  closeWindow() {
    if (this.subscriptionMapClick) {
      this.subscriptionMapClick.unsubscribe();
      this.subscriptionMapClick = null;
      this.setPunteroPosicionar(false);
    }
    this.windowCiudadanosForm.closeWindow();
  }

  // al expandir el formulario
  onExpand(event: any) {
    if (this.subscriptionMapClick) {
      this.subscriptionMapClick.unsubscribe();
      this.subscriptionMapClick = null;
      this.setPunteroPosicionar(false);
    }
  }

  public onClose() {
    this.removeMarker();
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  /*
    Comprueba el email del ciudadano,
    si existe NO se muestra un mensaje de error
  */
    private ultimoEmailVerificado: string = '';

    public async checkCiudadano(event: any): Promise<void> {
      this.ciudadanoEmailExist = false;
      const email = event.target.value;

      if (!email || email === this.ultimoEmailVerificado) {
        return;
      }

      this.ultimoEmailVerificado = email;

      const emailValido = this.validateEmailFormat(email);

      if (!emailValido) {
        return;
      }

      if (this.ciudadano && this.ciudadano.id === 0) {
        this.ciudadanoEmailExist = await this.ciudadanoService.checkCiudadanoExist(email);
      } else {
        this.ciudadanoEmailExist = false;
      }
    }

    protected validateEmailFormat(email: string): boolean {
      if (email === '') {
        return true;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
      return emailRegex.test(email);
    }

    protected get emailFormatoValido(): boolean {
      return this.validateEmailFormat(this.ciudadano?.correoElectronico);
    }

    protected validateDNIFormat(dni: string): boolean {

      if(dni===''){
        return true;
      }
      const dniRegex = /^\d{8}[A-Za-z]$/;
      return dniRegex.test(dni);
    }

    protected get dniFormatoValido(): boolean {
      return this.validateDNIFormat(this.ciudadano?.nif) || !this.ciudadano?.nif && !this.camposLopd['nif']?.obligatorio ;
    }

    protected get FormatoValido(): boolean {
      return (
        this.validateEmailFormat(this.ciudadano?.correoElectronico) &&
        this.validateDNIFormat(this.ciudadano?.nif)
      );
    }

  onMapSearch(event: any) {
    this.ciudadano.direccion = event.place.Street;
    this.ciudadano.codigoPostal = event.place.PostalCode;
    this.ciudadano.poblacion = event.place.District;
    this.ciudadano.municipio = event.place.Locality;
    this.ciudadano.provincia = event.place.AdministrativeArea2;
    this.ciudadano.comunidadAutonoma = event.place.AdministrativeArea1;
    this.ciudadano.numero = event.place.StreetNumber;

    if(this.inputMapSearch) {
      this.inputMapSearch.value = '';
    }
  }

  setPunteroPosicionar(posicionando: boolean) {
    const mapContainer = <HTMLElement>document.getElementsByClassName('gm-style')[0]?.children[0] ||  <HTMLElement>document.querySelector('movisat-map');
    if (posicionando) {
      mapContainer.classList.add('setPosition');
    } else {
      mapContainer.classList.remove('setPosition');
    }
  }

  private subscriptionMapClick: any = null;

  onPosicionar() {
    this.windowCiudadanosForm.collapseWindow();
    // Cambio el puntero del ratón sobre el mapa
    this.setPunteroPosicionar(true);
    if (!this.subscriptionMapClick) {
      this.subscriptionMapClick = this.subscribeOnMapClick();
    }
  }

  // Cada vez que se pincha sobre la cartogafía
  subscribeOnMapClick(): any {
    return this.map.subscribeOnMapClick(
      this,
      async (_this: any, position: MapLatLng) => {
        let direccion = await this.zonesService.getDireccion(position.lat, position.lng);
        this.ciudadano.direccion = direccion.Street;
        this.ciudadano.numero = direccion.StreetNumber;
        this.ciudadano.codigoPostal = direccion.PostalCode;
        this.ciudadano.poblacion = direccion.District;
        this.ciudadano.municipio = direccion.Locality;
        this.ciudadano.provincia = direccion.AdministrativeArea2;
        this.ciudadano.comunidadAutonoma = direccion.AdministrativeArea1;
        this.subscriptionMapClick.unsubscribe();
        this.subscriptionMapClick = null;
        this.setPunteroPosicionar(false);
        try {
          this.windowCiudadanosForm?.expandWindow();
        } catch (error) {
          console.debug(error);
        }
      }
    );
  }

  changeValidado(event: any) {
    let newValue = event.args.item.value;

    if (newValue === AppComponent.translate('Pendiente')) {
      this.ciudadano.estadoValidacion = 14;
    } else if (newValue === AppComponent.translate('Validado')) {
      this.ciudadano.estadoValidacion = 15;
    } else if (newValue === AppComponent.translate('Rechazado')) {
      this.ciudadano.estadoValidacion = 16;
    }

    this.disableTabs();
    this.enableTabs();
  }

  asignarDireccion(event: DireccionModel) {
    this.direccion = null;
    this.direccion = event;

    this.ciudRibbon.selectAt(2);
  }

  public async onGuardar(): Promise<void> {
    this.showLoader = true;

    if (!this.ciudadanoEmailExist && this.FormatoValido) {
      if (this.ciudadano.direccion == null) {
        this.showLoader = false;
        MainComponent.getInstance().showError(
          'ATENCION',
          'Introduzca_direccion',
          2000
        );
        return;
      }

      if (this.selectorCatastro && this.selectorCatastro.catastro &&
          (this.selectorCatastro.catastro.titular !== '' ||
           this.selectorCatastro.catastro.referenciaCatastral !== '')) {
        await this.saveCatastro();
      }

      await this.saveCiudadano();
    } else {
      this.showLoader = false;
      MainComponent.getInstance().showError(
        'ATENCION',
        'Revisa_campos_formulario',
        2000
      );
    }
  }


  async saveCatastro() {
    if (this.selectorCatastro.catastro.referenciaCatastral !== '') {
      try {
        await this.catastroService.saveCatastro(this.selectorCatastro.catastro);
      } catch (error) {
      }
    } else {
      MainComponent.getInstance().showWarning(
        'ATENCION',
        'No_se_ha_indicado_un_numero_de_catastro',
        2000
      );
    }
  }

  validateRequiredFields(): string[] {
    const requiredValuesAreSet = Object.entries(this.camposLopd).map(([nombreCampo, propiedadesCampo]) => {
      if (propiedadesCampo.obligatorio && !this.ciudadano[nombreCampo]) {
        return propiedadesCampo.textToShow;
      }
    }).filter(function( requiredField ) {
      return requiredField !== undefined;
    });

    return requiredValuesAreSet;
  }

  async saveCiudadano() {
    // Validar campos obligatorios
    const requiredFields = this.validateRequiredFields();
    if (requiredFields.length !== 0) {
      this.showLoader = false;
      MainComponent.getInstance().showError(
        'ATENCION',
        'Revisa_campos_formulario_obligatorios',
        2000,
        true,
        requiredFields.join(', ')
      );
      return;
    }

    let ciudadanoOriginal = { ...this.ciudadano };

    const savedCiudadano = await this.ciudadanoService.saveCiudadano(this.ciudadano);

    if(!savedCiudadano) {
      this.showLoader = false;
    }

    if (ciudadanoOriginal.id !== 0) {
      this.guardar = true;
      this.removeMarker();
      await this.ciudadanoTarjetas.onGuardar();
    }

    const ciudadanoGetted = await this.ciudadanoService.getCiudadano(savedCiudadano.id);

    if(!ciudadanoGetted) {
      this.showLoader = false;
      return;
    }

    this.ciudadano = ciudadanoGetted;

    if (ciudadanoOriginal.id === 0) {
      if (!this.ciudadano.direcciones) {
        this.ciudadano.direcciones = [];
      }

      switch (this.ciudadano.estadoValidacion) {
        case 15:
          this.ciudadano.validadoTexto = this.translate('Validado');
          break;
        case 16:
          this.ciudadano.validadoTexto = this.translate('Rechazado');
          break;
        default:
          this.ciudadano.validadoTexto = this.translate('Pendiente');
          break;
      }

      this.ciudRibbon.enableAt(1);
      this.enableTabs();
    } else {
      this.windowCiudadanosForm.closeWindow();
    }

    MainComponent.getInstance().showInfo(
      'ATENCION',
      'Registro_almacenado',
      2000
    );
    this.createCiudadano.emit(this.ciudadano);
    this.showLoader = false;
  }

  expandForm(){
    this.windowCiudadanosForm.expandWindow();
    this.windowCiudadanosForm.bringToFront();
  }
}
